import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import styles from 'styles/image_picker.module.scss';
import { DragAndDrop, Icon } from 'components';
import {
	faUpload,
} from '@fortawesome/fontawesome-pro-solid';
import classNames from 'lib/classNames';
import { API } from 'aws-amplify';
import useRefState from 'hooks/useRefState';

const ImagePicker = ({ onChange, value, simplified = false }) => {
	const input = useRef(null);
	const [preview, setPreview] = useState(value)
	const readImage = ({ target }) => {
		if (target.files && target.files[0]) {
			const file = target.files[0]
			const reader = new FileReader();
			reader.onload = async function (event) {
				//TODO: update ui to show a loading indicator
				const value = event.target.result
				setPreview(value)
				const body = {
					fileName: file.name,
					attachment: value.replace(/data:.*\/.*;base64,/, "")
				}
				// const response = await API.post("API_GATEWAY_NEW", "/uploadImage", { body });
				// console.log("response", response);
				// onChange(response.public_url);
			};
			reader.readAsDataURL(file);
		}
	};
	const handleDrop = files => {
		input.current.files = files;
		readImage({ target: input.current });
	};
	const id = `fp-${new Date().getTime()}`;
	const hasPreview = value || preview
	return (
		<div className={styles.ImagePicker}>
			<input type="file" id={id} onChange={e => readImage(e)} ref={input} />
			<label htmlFor={id} className="label">
				{
					simplified ?
						<span className={classNames('flex-1 flex-grow ml-2 text-gray-500 text-sm font-bold  cursor-pointer')}>Upload my own <Icon icon={faUpload} color="" /></span>
						:
						<DragAndDrop handleDrop={f => handleDrop(f)}>
							{hasPreview && (
								<Fragment>
									<div className={styles.previewWrapper}>
										<div className={styles.previewImage} style={{ backgroundImage: `url(${preview})` }} />
										{value && <div className={styles.image} style={{ backgroundImage: `url(${value})` }} />}
									</div>
									<small>Change</small>
								</Fragment>
							)}
							{!hasPreview && (
								<p>
									<b>Choose an image </b> or drag it here.
								</p>
							)}
						</DragAndDrop>
				}

			</label>
		</div>
	);
};
const reader = new FileReader();
const ImagePicker2 = ({ onChange, value }) => {
	const input = useRef(null);
	const [preview, setPreview, previewRef] = useRefState(value)
	const [uploading, setUploading, uploadingRef] = useRefState(false)
	const readImage = ({ target }) => {
		if (target.files && target.files[0]) {
			setUploading(true)
			reader.readAsDataURL(target.files[0]);
		}
	};
	const handleDrop = files => {
		input.current.files = files;
		readImage({ target: input.current });
	};
	const id = `fp-${new Date().getTime()}`;
	const hasPreview = value || previewRef.current
	useEffect(() => {
		reader.onload = async function (event) {
			console.log(event.target);
			const value = event.target.result
			setPreview(value)
			const body = {
				fileName: input.current.files[0].name,
				attachment: value
			}
			try {
				const response = await API.post("API_GATEWAY_NEW", "/uploadImage", { body });
				onChange(response.public_url);
				setPreview(response.public_url)
			} catch (error) {
				setPreview(undefined)
			}
			setUploading(false)
		};
	}, [])
	return (
		<Fragment>
			<input type="file" className={classNames("hidden")} id={id} onChange={e => readImage(e)} ref={input} />
			<label htmlFor={id} className={classNames("flex justify-center w-full h-32 px-4 transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none")}>
				<DragAndDrop handleDrop={f => handleDrop(f)} className={classNames("w-full h-full flex-center space-x-2")}>
					{/* <div className={classNames("w-full h-full flex-center space-x-2")}> */}
					{hasPreview && (
						<Fragment>
							<div>
								<div className={classNames("w-24 h-24 rounded bg-cover bg-center border-2 border-white shadow rounded")} style={{ backgroundImage: `url(${previewRef.current})` }}>
									<div className={classNames("flex-center w-full h-full bg-cover bg-center")} style={{
										background: uploadingRef.current ? "rgba(255,255,255,0.72)" : undefined,
									}}>
										<svg className={classNames("animate-spin h-5 w-5 text-blue-500", { hidden: !uploadingRef.current })} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
											<circle className={classNames("opacity-25")} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
											<path className={classNames("opacity-75")} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
										</svg>
										<span className={classNames("bg-black text-white font-bold p-2 rounded bg-opacity-60 text-xxs tracking-wider uppercase", { hidden: uploading || !value })}>change</span>
									</div>
								</div>
							</div>
						</Fragment>
					)}
					{!hasPreview && (
						<div className={classNames("flex flex-col")}>
							<div className={classNames("opacity-0 mb-2 mx-auto") + " " + styles.dots} />
							<div className={classNames("flex space-x-2")}>
								<svg xmlns="http://www.w3.org/2000/svg" className={classNames("w-6 h-6 text-gray-600")} fill="none" viewBox="0 0 24 24"
									stroke="currentColor" strokeWidth="2">
									<path strokeLinecap="round" strokeLinejoin="round"
										d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
								</svg>
								<span className={classNames("font-semibold text-gray-600")}>
									Drop images here, or <span className={classNames("text-blue-500 underline")}>browse</span>
								</span>
							</div>
							<div className={classNames(uploadingRef.current && !previewRef.current ? "visible" : "invisible", "mt-2 mx-auto") + " " + styles.dots} />
						</div>
					)}
					{/* </div> */}
				</DragAndDrop>
			</label>
		</Fragment>
	);
};

export default ImagePicker2;
